<template>
  <div class="time-dur-event" v-tippy="{ placement : 'top-start',  arrow: true, onShown: () => {userTime()} }" :content="`${$t('tooltips.time')} ${userCurrentTimeZone}`">
    <div class="time">
      <span>{{ time }}</span>
      <Online :online="online" size="sm" />
    </div>
    <div class="dur">
      <span>({{ dur }})</span>
    </div>
  </div>
</template>

<script>
import Online from '@/components/user/Online'
import moment from 'moment-timezone'

export default {
  name: 'TimeDurEvent',
  props: {
    event: {},
    online: Boolean,
  },
  data() {
    return {
      userCurrentTimeZone: ""
    }
  },
  components: { Online },
  mounted() {
    this.userTime()
  },
  computed: {
    time() {
      const start = moment(this.event?.time_start).format('HH:mm')
      const end = moment(this.event?.time_finish).format('HH:mm')
      return `${start} - ${end}`
    },
    dur() {
      const min = moment.duration(this.event?.time_finish - this.event?.time_start).asMinutes()
      return `${min} ${this.$t('events.time-duration.min')}`
    },
  },
  methods: {
    userTime() {
      this.userCurrentTimeZone = `${moment().format('LT')} (${moment.tz.guess()})`;
    }
  }
}
</script>

<style lang="scss">
.time-dur-event {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  flex-shrink: 0;

  .time {
    display: flex;
    align-items: center;

    .online-status-dote {
      margin-left: 8px;
    }
  }

  .dur {
    color: $dark;
  }
}
</style>
